import type { SVGProps } from "react";

export function ArrowLeftIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12H19M5 12L11 18M5 12L11 6"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowRightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12H5M19 12L13 18M19 12L13 6"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowBigRightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.69043 24.9984V14.9984M10.6904 24.9984V14.9984M20.6904 24.9984V30.9751C20.6905 31.3047 20.7883 31.6269 20.9714 31.9009C21.1546 32.1749 21.4148 32.3885 21.7193 32.5146C22.0238 32.6407 22.3589 32.6737 22.6821 32.6094C23.0054 32.5451 23.3023 32.3865 23.5354 32.1534L34.5121 21.1768C34.8245 20.8642 35.0001 20.4404 35.0001 19.9984C35.0001 19.5565 34.8245 19.1327 34.5121 18.8201L23.5354 7.84345C23.3023 7.61043 23.0054 7.45175 22.6821 7.38747C22.3589 7.3232 22.0238 7.3562 21.7193 7.48232C21.4148 7.60843 21.1546 7.822 20.9714 8.09602C20.7883 8.37003 20.6905 8.6922 20.6904 9.02178V14.9984H15.6904V24.9984H20.6904Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowUpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5L12 19M12 5L6 11M12 5L18 11"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 19L12 5M12 19L18 13M12 19L6 13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
